import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import axios from 'axios';
import settings from '../settings';
import { isUrl } from '../utils/index';

export default class Image extends Component {
  state = {
    src: ''
  };

  fetchImage = (url) => {
    axios.get(`${settings.api.url}${url}`)
          .then((response) => {
            this.setState( { src: response.data.thumbnail });
          })
          .catch((response) => {

          });
  };

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.src != nextProps.src) {
      this.fetchImage(nextProps.src);
    }
  }
  componentWillMount() {
    this.fetchImage(this.props.src);
  }

  render() {
    let src = this.props.dataURI || this.state.src;

    return <img className={this.props.className} src={src} />;
  }
};



// WEBPACK FOOTER //
// ./src/components/Image.jsx